import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom';
import {RoutesEnum, routesPaths} from '../../routes/routes';
import {LoginAction} from '../../store/actions/LoginAction';
import {useDispatch, useSelector} from "react-redux";
import {getErrorMessage} from "../../store/selectors/getErrorMessage";
import {AppDispatch} from "recharts/types/state/store";


export default function Login(): React.ReactElement<HTMLDivElement> {

    const errorMessage: string = useSelector(getErrorMessage);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>()

    const onSubmit = (e: any) => {
        e.preventDefault()
        navigate(routesPaths[RoutesEnum.HOME]);
        dispatch(LoginAction({username, password}));
    }

    return <div className='h-screen flex justify-center items-center'>
        <form className='w-96 p-8 mb-4 flex flex-col bg-login-bg border rounded-md' onSubmit={onSubmit}>
            <div className='py-4 text-center font-semibold'>Sign in to your account</div>
            <div className='mb-4'>
                <label className='block text-grey-darker text-sm font-bold mb-2' htmlFor='username'>
                    Username:
                </label>
                <input
                        type='text'
                        id='username'
                        name='username'
                        className='shadow appearance-none border text-sm rounded w-full py-2 px-3 text-grey-darker'
                        value={username}
                        onChange={({target}) => setUsername(target.value)}
                />
            </div>

            <div className='mb-6'>
                <label className='block text-grey-darker text-sm font-bold mb-2' htmlFor='password'>
                    Password:
                </label>
                <input
                        type='password'
                        id='password'
                        name='password'
                        className='shadow appearance-none border border-red rounded w-full py-2 px-3 text-grey-darker mb-3'
                        value={password}
                        onChange={({target}) => setPassword(target.value)}
                />
            </div>

            <div>
                <button
                        id='login-btn'
                        title='Login'
                        name='submit'
                        className='bg-[#161D22] hover:bg-blue-600 text-white font-bold py-2 px-4 rounded w-full'
                        onClick={onSubmit}
                >Login
                </button>
            </div>

            <p className='h-12 text-sm text-red-400'>{errorMessage}</p>

        </form>
    </div>

}
